/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysourcesearch2Inputs */

const en_summarysourcesearch2 = /** @type {(inputs: Summarysourcesearch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search engines`)
};

const de_summarysourcesearch2 = /** @type {(inputs: Summarysourcesearch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchmaschinen`)
};

/**
* | output |
* | --- |
* | "Search engines" |
*
* @param {Summarysourcesearch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysourcesearch2 = /** @type {((inputs?: Summarysourcesearch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysourcesearch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysourcesearch2(inputs)
	return de_summarysourcesearch2(inputs)
});
export { summarysourcesearch2 as "summarySourceSearch" }